module.exports = __webpack_public_path__ + "static/img/user-default-thumb.10c25e42.png";